<template>
  <component class="fs-db-28" :is="tag">{{ label }}</component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: "span",
    },
    label: {
      type: String,
      default: "",
    },
  },
};
</script>